import { isInteger } from "lodash";

export const RESPONSE_CODE_STORAGE = {
    Not_invite_your_self: 14,
    Not_enough_space_to_invite: 13,
    Inviter_has_been_invited: 12,
    Using_shared_storage: 11,
    Success: 100,
    Failed: 400,
    Email_not_exit: 404,
    Not_accept_invitation_when_accept_other_invitation: 13,
    Not_accept_invitation_when_invited_other_people: 14,
    Not_permission: 403,
    Not_found_invitation: 404,
    Not_accept_invitation_when_invitation_retrieved: 15,
}

const roundUpToTwoDecimals = (num) => {
    // Nhân số với 100 và làm tròn lên
    let roundedNum = Math.ceil(num * 100) / 100;
    // Chuyển đổi thành chuỗi với 2 chữ số thập phân
    return roundedNum.toFixed(2);
  }

export const convertFromByte = (value) => {
    const valueMB = value / 1024 / 1024;
    if(valueMB > 1024){
        const valueGB = valueMB / 1024;
        const convertValueGB = roundUpToTwoDecimals(valueGB)
        if(isInteger(convertValueGB)){
            return `${valueGB} GB`;
        } else {
            return `${convertValueGB} GB`;
        }
    } else {
        const convertValueMB = roundUpToTwoDecimals(valueMB)
        if(isInteger(convertValueMB)){
            return `${valueMB} MB`;
        } else {
            return `${convertValueMB} MB`;
        }
    }
}

export const convertByteToGb = (b) => {
    if(!b){
        let num = 0;
        return num.toFixed(2);
    }

    const valueGB = parseInt(b)/(1024 * 1024 * 1024);
    const convertValueGB = roundUpToTwoDecimals(valueGB)
    if(isInteger(convertValueGB)){
        return valueGB;
    } else {
        return convertValueGB;
    }
}

export const WarningFullStorage = () => {
    return (
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0001 1.98969L17.5301 14.9997H2.47012L10.0001 1.98969ZM0.740121 13.9997C-0.0298788 15.3297 0.930121 16.9997 2.47012 16.9997H17.5301C19.0701 16.9997 20.0301 15.3297 19.2601 13.9997L11.7301 0.989688C10.9601 -0.340312 9.04012 -0.340312 8.27012 0.989688L0.740121 13.9997ZM9.00012 6.99969V8.99969C9.00012 9.54969 9.45012 9.99969 10.0001 9.99969C10.5501 9.99969 11.0001 9.54969 11.0001 8.99969V6.99969C11.0001 6.44969 10.5501 5.99969 10.0001 5.99969C9.45012 5.99969 9.00012 6.44969 9.00012 6.99969ZM9.00012 11.9997H11.0001V13.9997H9.00012V11.9997Z" fill="#D66905"/>
        </svg>

    )
}

export const calculatePercentValue = (value, maxValue) => {
    const calValue = value / maxValue * 100;
    let valueReturn = 0;
    if((maxValue === 0 || maxValue === 0.00)){
        return "";
    }
    if(calValue === 0){
        valueReturn = 0;
    } else if(calValue < 1){
        valueReturn = 1;
    } else if(calValue >= 1 && calValue < 100){
        valueReturn = Math.floor(calValue);
    } else if(calValue === 100){
        valueReturn = 100;
    } else if(calValue > 100){
        valueReturn = Math.ceil(calValue);
    } else {
        valueReturn = 0;
    }
    return `${valueReturn}%`
}

export const RECORD = {
    ALL: 0,
    OVER: 1
}